import { render, staticRenderFns } from "./DialogInvitationRewards.vue?vue&type=template&id=40f2fa7b&scoped=true"
import script from "./DialogInvitationRewards.vue?vue&type=script&lang=js"
export * from "./DialogInvitationRewards.vue?vue&type=script&lang=js"
import style0 from "./DialogInvitationRewards.vue?vue&type=style&index=0&id=40f2fa7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2fa7b",
  null
  
)

export default component.exports